import Modal from "react-modal";
import { Container, Contents, Title } from "./styled";

import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ChevronDownIcon, XMarkIcon } from "@heroicons/react/24/outline";

import { useEffect, useState } from 'react'
import { toast } from "react-toastify";


const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        width: "540px",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "transparent",
        padding: "0px",
        margin: "0px",
        borderRadius: "8px",
        border: "none"
    },
    overlay: {
        backgroundColor: "rgba(10,23,55,0.5)",
        zIndex: "99999999"
    },
};




const ModalUpdateCode = (props) => {

    const dispatch = useDispatch()
    const language = useSelector((state) => state.reducerLanguage);
    const { id } = useParams();
    const reducerUpdateCodes = useSelector((state) => state.reducerUpdateCodes);

    const [code, setCode] = useState(props.item.serial_number)
    const [used, setUsed] = useState(props.item.used)


    const closeModal = () => {
        //props.handleClick()

        setTimeout(() => {
            props.setVisible(false)
            //props.goSearch()
            //props.setDataModalDeleteCompleted([])
        }, 0);
    }

    useEffect(() => {

    }, [])


    const update = () => {
        dispatch({ type: "SAGA_UPDATE_CODES", payload: { code: { serial_number: code, used: Number(used) }, id: props.item.id } })
        //closeModal()
    }

    useEffect(() => {

        if (reducerUpdateCodes.loading == false && reducerUpdateCodes.error == false && reducerUpdateCodes.data.length == 0) {
        } else {

            const id = "reducerUpdateCodes"
            if (reducerUpdateCodes.loading) {
                toast.loading("Aguarde..", { toastId: id })
            } else {
                if (reducerUpdateCodes.error) toast.update(id, { render: "Erro ao atualizar código", type: "error", isLoading: false, hideProgressBar: false, autoClose: 3000, closeOnClick: true });
                else {
                    toast.update(id, { render: "Código atualizado com sucesso", type: "success", isLoading: false, hideProgressBar: false, autoClose: 2000, closeOnClick: true })
                    props.goSearch()
                    closeModal()
                    //props.setVisible(false)
                    //goSearch()
                    dispatch({ type: "CODES_UPDATE_RESET" })
                }
            }
        }
    }, [reducerUpdateCodes])

    return (
        <Modal
            isOpen={props.visible}
            style={customStyles}
            ariaHideApp={false}
            onRequestClose={() => { }}


        >

            <Container>
                <Title>
                    <div>
                        <label>Editar código</label>
                        <XMarkIcon onClick={() => { closeModal() }} style={{ cursor: "pointer" }} width={20} />
                    </div>
                    {/* <label >
                        Aguarde enquanto excluímos os arquivos selecionados.
                    </label> */}
                </Title>
                <Contents>
                    <div>
                        <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                            Código
                        </label>
                        <div className="mt-2">
                            <input
                                id="name"
                                name="name"
                                type="text"
                                placeholder=""
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-[#111827] sm:text-sm/6"
                            />
                        </div>
                    </div>

                    <div>
                        <label htmlFor="location" className="block text-sm/6 font-medium text-gray-900">
                            Status
                        </label>
                        <div className="mt-2 grid grid-cols-1">
                            <select
                                onChange={(e) => { setUsed(e.target.value) }}
                                id="location"
                                name="location"
                                className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-[#111827] sm:text-sm/6"
                            >
                                <option value={0} selected={used == 0 ? true : false}>Disponivel</option>
                                <option value={1} selected={used == 1 ? true : false}>Indisponível</option>
                            </select>
                            <ChevronDownIcon
                                aria-hidden="true"
                                className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                            />
                        </div>
                    </div>

                    <div className="flex shrink-0 justify-end px-4 py-4">
                        <button
                            type="button"
                            onClick={() => { closeModal() }}
                            className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400"
                        >
                            Cancelar
                        </button>
                        <button
                            onClick={() => { update() }}
                            type="submit"
                            className="ml-4 inline-flex justify-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-500"
                        >
                            Salvar
                        </button>
                    </div>
                </Contents>
            </Container>

        </Modal >
    )
}

export default ModalUpdateCode

